import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackage"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H8V10H16V3H21V21H3V3ZM14 16V18H18V16H14Z" fill="currentColor"/><Path d="M10 3H14V8H10V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackage;
